import { ContactTypes } from "@/types/common.types.ts";
import {
  ButtonLink,
  FontAwesomeIcon,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface ContactButtonProps {
  type: ContactTypes;
  contact: string;
}

const contactConfig = {
  telegram: {
    icon: "fa-brands fa-telegram",
    hoverColor: "hover:text-[#0088cc]",
    getUrl: (contact: string) => {
      return `https://telegram.me/+${contact}`;
    },
    contactName: "Telegram",
  },
  whatsapp: {
    icon: "fa-brands fa-whatsapp",
    hoverColor: "hover:text-positive",
    getUrl: (contact: string) => {
      return `https://wa.me/${contact}`;
    },
    contactName: "WhatsApp",
  },
  viber: {
    icon: "fa-brands fa-viber",
    hoverColor: "hover:text-[#AB2C78]",
    getUrl: (contact: string) => {
      if (contact.startsWith("1") || contact.length > 10) {
        return `viber://chat/?number=%2B${contact}`;
      } else {
        return `viber://chat/?number=2B${contact}`;
      }
    },
    contactName: "Viber",
  },
};

export const ContactButton = ({ type, contact }: ContactButtonProps) => {
  const { t } = useTranslation();
  const config = contactConfig[type];

  return (
    <Tooltip delay={false}>
      <TooltipTrigger>
        <ButtonLink variant="plain" href={config.getUrl(contact)} size="sm" blank>
          <FontAwesomeIcon className={`text-icon-16 ${config.hoverColor} `} icon={config.icon} />
        </ButtonLink>
      </TooltipTrigger>
      <TooltipContent>
        <Text className="text-white">{`${t("common:chat_in")} ${config.contactName}`}</Text>
      </TooltipContent>
    </Tooltip>
  );
};

export default ContactButton;
